import React, { useRef, useState, useEffect, Fragment } from "react";
import Multiselect from "multiselect-react-dropdown";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "context/baseUrl/baseUrl";
import { useHistory } from "react-router-dom";
import "./User.scss";
import {
  checkEmpty,
  dateParser,
  statusToText,
  statusToTextActiveInactive,
} from "services/utils/commonFunctions/CommonFunctions";
import FormSection from "components/form/FormSection";
import Images from "assets/images/imageData";
import Loader from "components/loader/loader";
import { trim } from "lodash";
import {Button, input, form} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import MainLayout from "components/mainLayout/MainLayout";
import callWebService, { callTypes } from "services/utils/networks/network";
import Config from "services/config/config";
import ConstVar from "constants/const";
import DropdownFilter from "components/input/dropdown/dropDownFilter";
import CustomModal from "components/modal/modal";

const User = ({ match, documentList }) => {
  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];
  const [smallModal, setSmallModal] = useState({
    hover1: false,
    hover2: false,
    show: false,
  });
  const nameRef = useRef();
  const [activeComponent, setActiveComponent] = useState();
  const history = useHistory();
  const scrl = useRef(null);
  const [totalDocuments, setTotalDocuments] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [dataList, setdataList] = useState([]);
  const [pageNos, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [documentData, setDocumentData] = useState([]);
  const [partnerName, setPartnerName] = useState("");
  const [show, setShow] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [editDocument, setEditDocument] = useState(false);
  const [documentDoc, setDocumentDoc] = useState({
    documentDocFormat: [],
  });
  const [docTypeCheck, setDocTypeCheck] = useState([]);
  const [addDocumentData, setAddDocumentData] = useState({
    documentName: "",
    documentCode: "",
    documentType: "",
    documentTypeId: "",
  });

  const [leadModule] = useState([
    {
      id: 1,
      name: "Lead List"
    },
    {
      id: 2,
      name: "Lead Detail"
    }
  ]) 

  const [editDocumentData, setEditDocumentData] = useState();

  const [errMsg, setErrMsg] = useState({
    documentName: "",
    documentCode: "",
    documentType: "",
    docFormat: "",
    docTypeCheck: "",
  });

  const handleAscendingOrder = () => {};

  const handleDescendingOrder = () => {};

  const nextPage = async () => {
    setPageNo(pageNos + 1);
  };
  const previousPage = async () => {
    setPageNo(pageNos - 1);
  };

  const handleSearch = async () => {
    if (!nameRef.current.value) return;
    setPageNo(1);
    setisLoading(true);
    const data = {
      searchName: trim(nameRef.current.value),
      pageSize: perPageRecord,
    };
    const res = await documentList(data);
    if (res?.data?.data?.documentTypes) {
      setDocumentData(res?.data?.data?.documentTypes);
      setTotalDocuments(res?.data?.data?.pagination?.total_rows);
    }
    setisLoading(false);
  };

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    const data = {
      pageNo: 1,
      pageSize: parseInt(event.target.value),
      searchName: trim(nameRef.current.value),
    };
    const res = await documentList(data);
    if (res?.data?.data?.documentTypes) {
      setDocumentData(res?.data?.data?.documentTypes);
      setTotalDocuments(res?.data?.data?.pagination?.total_rows);
    }
    setisLoading(false);
  };

  const handleReset = async () => {
    window.location.reload();
  };

//   useEffect(() => {
//     const getData = async () => {
//       setisLoading(true);
//       const data = {
//         searchName: nameRef.current.value,
//         pageNo: pageNos,
//         pageSize: perPageRecord,
//       };
//       const res = await documentList(data);
//       if (res?.data?.data?.documentTypes) {
//         setDocumentData(res?.data?.data?.documentTypes);
//         setTotalDocuments(res?.data?.data?.pagination?.total_rows);
//       }
//       setisLoading(false);
//     };
//     getData();
//   }, [pageNos]);

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Role Name",
      "Action",
    ];

    return headerElement.map((key, index) => {
        return <th key={index}>{key}</th>;
    });
  };
  useEffect(() => {
    // (async () => {
    //   const data = {
    //     searchName: "",
    //     pageNo: pageNos,
    //     pageSize: perPageRecord,
    //   };
    //   const res = await documentList(data);
    //   if (res?.data?.data?.documentTypes) {
    //     setDocumentData(res?.data?.data?.documentTypes);
    //     setTotalDocuments(res?.data?.data?.pagination?.total_rows);
    //   }
    //   setisLoading(false);
    // })();
  }, []);

  const handleClose = () => {
    setShow(false);
    setEditDocument(false);
    setAddDocumentData({
      documentName: "",
      documentCode: "",
      documentType: "",
      documentTypeId: "",
    });
    setErrMsg({
      documentName: "",
      documentCode: "",
      documentType: "",
      docFormat: "",
      docTypeCheck: "",
    });
    setDocTypeCheck([]);
  };
  const handleShow = () => setShow(true);

  const documentChange = (e) => {
    const { name, value } = e.target;
    setAddDocumentData((state) => ({ ...state, [name]: value.toString() }));
  };

  const handleSubmit = async () => {
    try {
      if (docTypeCheck == 0) {
        setErrMsg((state) => ({
          ...state,
          docTypeCheck: "Enter document type",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, docTypeCheck: "" }));
      }

      if (addDocumentData.documentName === "") {
        setErrMsg((state) => ({
          ...state,
          documentName: "Enter document name",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentName: "" }));
      }
      if (addDocumentData.documentCode === "") {
        setErrMsg((state) => ({
          ...state,
          documentCode: "Enter document code",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentCode: "" }));
      }
      if (addDocumentData.documentType === "") {
        setErrMsg((state) => ({
          ...state,
          documentType: "Enter Document type",
        }));
        return;
      } else {
        setErrMsg((state) => ({ ...state, documentType: "" }));
      }

      setErrMsg("");
      setIsSubmit(true);
      const dataArray = [];
      docTypeCheck.forEach((f) => {
        dataArray.push(f.name);
      });
      const dataObj = {
        name: addDocumentData.documentName,
        code: addDocumentData.documentCode,
        type: addDocumentData.documentType,
        doc_format: dataArray,
        documentTypeId: addDocumentData.documentTypeId,
      };

      const res = await callWebService(
        callTypes.post,
        dataObj,
        Config.addDocumentCode
      );
      if (res.data.code === 200 || res.data.code === true) {
        setErrorMsg("");
        setSuccessMsg(res.data.message);
        setDocTypeCheck([]);
        setIsSubmit(false);
        setAddDocumentData({
          documentName: "",
          documentCode: "",
          documentType: "",
          documentTypeId: "",
        });
        setTimeout(() => {
          document.location.reload();
        }, 500);
      } else if ([409, 400].includes(res.data.code)) {
        setIsSubmit(false);
        setErrorMsg(res.data.data[0].message);
      }
    } catch (error) {
      console.log("ERRROR", error);
    }
  };

  //edit document
  const editDocumentDetail = (data) => {
    setShow(true);
    setEditDocument(true);
    setEditDocumentData(data);
    setIsSubmit(false);
    const documentEditObj = {
      documentName: data.name,
      documentCode: data.code,
      documentType: data.type,
      documentTypeId: data.id,
    };
    setAddDocumentData(documentEditObj);
    setDocumentDoc({ documentDocFormat: data.doc_format });
    const dataArray = [];

    data?.doc_format.forEach((f) => {
      let datas = {
        id: f,
        name: f,
      };
      dataArray.push(datas);
    });
    setDocTypeCheck(dataArray);
  };

  const checkValue = (val) => {
    if (documentDoc?.documentDocFormat?.includes(val)) {
      return "checked";
    }
  };
  const inputSearch = () => {
    return (
        <div style={{ display: "inline-block" }}>
          <input
            type="text"
            className="search-button"
            name="search"
            placeholder="Enter Role Name..."
            ref={nameRef}
          />
          &nbsp;
          <button className="btn btn-primary" onClick={handleSearch}>
            Submit
          </button>
          &nbsp;
          <button className="btn btn-warning" onClick={() => handleReset()}>
            Cancel
          </button>
        </div>
    );
  };
  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title={localization.addUser}
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
            <div class="form-row pl-3">
              <div class="form-group col-md-4">
                <label for="inputEmail4">User Name</label>
                <input type="email" class="form-control search-button document-search" id="inputEmail4" placeholder="Enter User Name"/>
              </div>
              <div class="form-group col-md-4">
                <label for="inputPassword4">Role</label>
                <select id="inputState" class="form-control search-button document-search">
                  <option selected>Choose...</option>
                  <option value="IT Admin">IT Admin</option>
                </select>
              </div>
            </div>
            <div class="form-row pl-3">
              <div class="form-group col-md-4">
                <label for="inputPassword4">Partners</label>
                <select id="inputState" class="form-control search-button document-search">
                  <option selected>Choose.Partner..</option>
                  <option value="IT Admin">BYJUS</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label for="inputZip">Email</label>
                <input type="email" class="form-control search-button document-search" id="email" placeholder="Enter Email" />
              </div>
            </div>
            <div className="form-row pl-3 mt-2">
              <div class="form-group col-md-8 col-md-offset-1">
                <table class="table">
                  <thead>
                     <tr>
                      <th>Module</th>
                      <th>Read</th>
                      <th>Write</th>
                    </tr>
                  </thead>
                  <tbody>                   
                    <tr>
                      <th>Partners</th>
                      <td> <input className="largerCheckbox" type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>Lead Modules</th>
                      <td> <input  type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input  type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>Document Codes</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>DMS</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>ESign</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>EMudra</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>Payment Log</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                    <tr>
                      <th>UTR</th>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                      <td> <input type="checkbox" id="inlineCheckbox1" value="option1" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
          
            {/* <div class="form-row pl-3">
              <div class="form-group col-md-2 col-md-offset-1">
                <label for="inputZip">Email</label>
                <input type="email" class="form-control search-button document-search" id="email" placeholder="Enter Email" />
              </div>
            </div> */}
            <div class="form-group pl-3 mt-3">
            <button type="submit" class="btn btn-primary">Submit</button></div>

            
          <Loader isLoading={isLoading} />
        </Layout>

        <Modal className="dms-modal" show={show} onHide={handleClose}>
          <Modal.Header closeButton style={{ backgroundColor: "#f7fcfd" }}>
            <Modal.Title>
              Edit Role
              <br />
              <span
                style={{
                  color: successMsg ? "green" : "red",
                  fontSize: "small",
                }}
              >
                {successMsg ? successMsg : errorMsg}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "" }}>
            <Col>
              <label className="mt-2">Role Name</label>
              <input
                type="text"
                name="documentName"
                className="search-button document-search"
                placeholder="Enter Role Name..."
                onChange={(e) => documentChange(e)}
                value={addDocumentData.documentName || ""}
              />
              <br />
              <span style={{ color: "red" }}>{errMsg.documentName}</span>
            </Col>
            
          </Modal.Body>
          <Modal.Footer>
            <Button variant="default" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              {isSubmit ? "Loading..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Modal>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default User;
